<template>
  <div class="row select-avaliation-item-strategy">
    <div class="col-12 pl-0 mt-2">
      <label for="description">Opções *</label>

      <!-- Options -->
      <div
        class="row pt-2"
        v-for="(option, index) in options"
        :key="index"
      >
        <div class="col pr-0 pr-md-3">
          <base-input
            :value="option"
            @input="updateOption(index, $event)"
            :error="validateMinLength(option)"
            placeholder="Descreva aqui uma opção"
          />
        </div>
        <div class="col-auto px-0 pr-md-2">
          <base-button
            class="ml-2 mt-2 mt-md-0"
            icon
            type="warning"
            @click="removeOption(index)"
            size="sm"
          >
            <span class="btn-inner--icon">
              <i class="fa fa-trash"></i>
            </span>
            <span class="btn-inner--text d-none d-md-block">Remover</span>
          </base-button>
        </div>
      </div>

      <!-- New  -->
      <div class="row pt-2">
        <div class="col pr-0">
          <input
            class="form-control"
            readonly
            style="background-color: #fff;"
            @focus="addOption"
            placeholder="Nova opção"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const DATABASE_MAX_LENGTH = 4000

export default {
  name: "SelectAvaliationItemStrategy",
  props: {
    value: {
      type: Object,
      default: () => ({
        min_length: 0,
        max_length: DATABASE_MAX_LENGTH,
      }),
    },
  },
  methods: {
    emitInput() {
      this.$emit("input", this.formData);
    },
    addOption() {
      console.log("[SelectAvaliationStrategy][addOption]this.$el", this.$el)
      this.options = [...this.options, ""];
      this.$nextTick(() => {
        this.$el.querySelector(".row:nth-last-child(2) input").focus();
      });
    },
    updateOption(index, value) {
      this.options[index] = value;
      this.options = [...this.options];
    },
    validateMinLength(option){
      return option.length < 1 ? "A opção deve ter pelo menos 1 caractere" : null;
    },
    removeOption(index){
      this.options = this.options.filter((_, i) => i !== index);
    },
  },
  computed: {
    formData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    options: {
      get() {
        return this.formData.options || [];
      },
      set(value) {
        this.formData.options = this.formData.options || [];
        this.formData = Object.assign({}, this.formData, { options: value });
      },
    },
  },
}
</script>
